/* eslint-disable import/no-anonymous-default-export */
import { object, string, number, array } from "yup";
export default object().shape({
  case_detail: object().shape({
    client_id: string().required("Client name is required"),
    case_details: object().shape({
      client_information: object().shape({}),
      case_information: object().shape({
        date_referred: string().required("Date refered is required"),
        case_type: string().required("Case type is required"),
      }),
      assigment_information: object().shape({}),
    }),
  }),
});
